// Normalize a pick document's `picks` field to a map keyed by game doc ID.
//
// Legacy picks were stored as an array indexed by the game's `displayOrder`,
// which silently misattributed picks whenever games were reordered, deleted,
// or added. New picks are stored as an object keyed by the game's stable
// Firestore doc ID. This bridges both shapes so every read path can key by id.
//
// `games` must carry `id` and (for the legacy path) `displayOrder`.
export function normalizePicks(picksData, games) {
  if (!picksData) return {};
  // Already keyed by gameId (new shape).
  if (!Array.isArray(picksData)) return picksData;
  // Legacy array: map by displayOrder, matching how scoring historically read
  // picks, so existing leaderboard results are preserved exactly.
  const map = {};
  for (const game of games || []) {
    const pick = picksData[game.displayOrder];
    if (pick !== undefined && pick !== null) {
      map[game.id] = pick;
    }
  }
  return map;
}

/**
 * Merge one card's change into a week's picks without mutating anything:
 * returns a new picks object whose `gameId` entry is a NEW object, and every
 * other game's entry is the SAME object as before. That identity contract is
 * what lets memoized PickScore cards skip re-rendering when a different game's
 * pick changes (and still re-render when their own does).
 * @param {Object<string, object>} picks   current picks keyed by game id
 * @param {string} gameId
 * @param {object} changes                 e.g. { awayScore: '21' }
 * @returns {Object<string, object>}
 */
export const applyPickChange = (picks, gameId, changes) => ({
  ...(picks || {}),
  [gameId]: { ...((picks && picks[gameId]) || {}), ...changes },
});
